import { Injectable } from '@angular/core';
import {ArcBaseService} from './arc-base.service';
import {LoadingService} from './loading.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfigService} from './config.service';
import {Observable} from 'rxjs';
import {loadModules} from 'esri-loader';

export class ProjectActionsLU {
  attributes: {
    projectsid_fk: number | string;
    Project_Actions: string;
    GlobalID: number | string;
  };
}

@Injectable()
export class ProjectActionsLuService extends ArcBaseService {
  constructor(snackBar: MatSnackBar, loadingService: LoadingService) {
    super('2', snackBar, loadingService);
  }
  create_new_action(project_fk, actions) {
    const vm = this;
    // const project = new Project();
    const config = new ConfigService();
    return new Observable<any>(obs => {
      vm.layerIsLoaded.subscribe(() => {
        loadModules(['esri/graphic', 'esri/geometry/Polygon', 'esri/SpatialReference'], config.jsapi_config).then(([Graphic, Polygon, SpatialReference]) => {
          const projectActions = new Graphic(vm.layer.templates[0].prototype.toJson());
          // project.setSymbol(vm.layer.renderer.getSymbol());
          // project.setGeometry(new Polygon(new SpatialReference(3857)));
          projectActions.attributes.GlobalID = 'new';
          projectActions.attributes.projectsid_fk = project_fk;
          projectActions.attributes.Project_Actions = actions;
          vm.addFeature(projectActions, true).subscribe();
          obs.next(projectActions);
          obs.complete();
        });
      });
    });
  }
}
